import { ClearDiv, Col3Col9, Divider, DynamicTextEditor } from '@aon/aon-tws-common-ui';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Constants from '../../../constants';
import ContentConstants from '../../../contentConstants';
import { IApplicationState } from '../../../store';
import { LabelAbove } from '../../common';
import { TranslationEditorContainer } from '../../../containers/translations/TranslationEditorContainer';
import { ActionCreators } from '../../../store/SurveyStore';
import { ITranslationEditItem } from '../../../models';

export default function SurveyInstruction() {
	const { surveyEditModel } = useSelector((store: IApplicationState) => store.survey);
	const dispatch = useDispatch();

	function HandleSurveyInstructionsChange(item: string) {
		dispatch(ActionCreators.HandleSurveyInstructionsChange(item));
	}
	function HandleTranslationEditorInstructionsUpdate(item: ITranslationEditItem) {
		dispatch(ActionCreators.HandleTranslationEditorInstructionsUpdate(item));
	}

	return (
		<>
			<Divider type='dashed' />
			<Col3Col9 label={ContentConstants.SUBSECTIONHEADERS_SURVEYINSTRUCTIONS}>
				<LabelAbove type='input'>{ContentConstants.INPUTLABEL_SURVEY_INSTRUCTIONS}</LabelAbove>
				<DynamicTextEditor
					id='survey-instructions-editor'
					inputType='textarea'
					enableHtmlEditor={true}
					placeholder={ContentConstants.SUBSECTIONHEADERS_SURVEYINSTRUCTIONS}
					onChange={HandleSurveyInstructionsChange}
					value={surveyEditModel.instructions.textValue}
					htmlEditorMode={'custom'}
					toolbarConfiguration={Constants.customHtmlEditorOptions}
				/>
				<ClearDiv clearHeight={'15px'} />
				{surveyEditModel.survey.surveyId !== 0 && (
					<TranslationEditorContainer
						enableHtmlEditor={true}
						property={'Instructions'}
						inputType={'textarea'}
						propertyDisplayName={ContentConstants.SUBSECTIONHEADERS_SURVEYINSTRUCTIONS}
						supportedCultures={surveyEditModel.supportedCultures}
						uniqueId={surveyEditModel.survey.surveyId}
						surveyId={surveyEditModel.survey.surveyId}
						defaultTranslation={surveyEditModel.instructions}
						notifyUpdate={HandleTranslationEditorInstructionsUpdate}
					/>
				)}
			</Col3Col9>
		</>
	);
}
